import React, { createContext, useReducer } from "react";
import { freeSpaceAreaInitialState } from '../reducers';
import constant from '../constants/freeSpaceAreaConstant';
import freeSpaceAreaReducer from "../reducers/freeSpaceAreaReducer";
import freeSpaceAreaService from "../services/freeSpaceAreaService";


export const freeSpaceAreaContext = createContext();
export const FreeSpaceAreaContextProvider = (props) => {

    const [state, dispatch] = useReducer(freeSpaceAreaReducer, freeSpaceAreaInitialState);

    const getFreeSpaceArea = (data,callBack) => {

        return freeSpaceAreaService.getFreeSpaceArea(data).then(x => {
           
                if (callBack) {
                    callBack(x);
                
            }

            return x;
        })      
    };
    const getLayerStructures = (data) => {

      
        freeSpaceAreaService.getLayerStructures().then(x => {
            if (x.success) {
                dispatch(success(x.data));
            }
        })
        function success(data) { return { type: constant.GET_LAYER_STRUCTURES, payload: data }; }
    };
    const selectedLayerStructers = (data) => {

        dispatch(success(data));
        function success(data) { return { type: constant.SET_SELECTED_LAYER_TYPES, payload: data }; }
    };
    const showDialog = (data) => {

        dispatch(success(data));
        function success(data) { return { type: constant.SET_FREE_SPACE_SHOW_DIALOG, payload: data }; }
    };
    return (
        <freeSpaceAreaContext.Provider value={[state,
            {
                getFreeSpaceArea,
                getLayerStructures,
                selectedLayerStructers,
                showDialog
            }]}>
            {props.children}
        </freeSpaceAreaContext.Provider>
    )
};
